<template>
  <div
    class="change-passwo-box show-flex-box-c show-flex-center"
    v-if="isShowChangepasswordPop"
    @click.self="closeChangePasswordPop()"
  >
    <div class="change-passwo-total show-flex-box-r show-flex-center">
      <div class="change-passwo-all show-flex-box-c">
        <em @click.self="closeChangePasswordPop()"></em>
        <dl>
          <dt class="change-passwo-title">
            <h3>修改密码</h3>
          </dt>
          <dd class="change-passwo-input show-flex-box-c show-flex-center">
            <h3 class="show-flex-box-c" v-if="isShowOldPwd">
              <strong>原密码</strong>
              <span class="show-flex-box-r">
                <input type="password" placeholder="请输入原密码" v-model="old_password" />
              </span>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>新密码</strong>
              <span class="show-flex-box-r">
                <input type="password" placeholder="请输入新密码" v-model="password" />
              </span>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>确认密码</strong>
              <span class="show-flex-box-r">
                <input type="password" placeholder="请输入确认密码" v-model="surepassword" />
              </span>
            </h3>
          </dd>
          <dd class="change-passwo-next-botton show-flex-box-r show-flex-center">
            <span @click="sureChangePassword()">确定</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";
// import {LoginUser} from "@/model/login_user.js";

export default {
  name: "changeBindPhone",
  data() {
    return {
      isShowChangepasswordPop: false,
      old_password: "",
      password: "",
      surepassword: "",
      isShowOldPwd: true
    };
  },
  props: {
    hasPwd: {
      type: [Boolean],
      default: true
    }
  },
  components: {},
  computed: {
    listenUserInfo: function() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.checkIsHadPassword();
  },
  methods: {
    checkIsHadPassword: function() {
      if (
        !(this.listenUserInfo && this.listenUserInfo.has_password) ||
        !this.hasPwd
      ) {
        this.isShowOldPwd = false;
      }
    },
    closeChangePasswordPop: function() {
      this.isShowChangepasswordPop = !this.isShowChangepasswordPop;
      this.resetFrom();
      if (!this.hasPwd) {
        this.$emit("updata-bind-success");
      }
    },
    sureChangePassword: function() {
      if (this.isShowOldPwd) {
        if (regex.isEmpty(this.old_password)) {
          this.$message({
            showClose: true,
            message: "请填写旧密码",
            type: "warning"
          });

          return;
        }
      }
      if (regex.isEmpty(this.password)) {
        this.$message({
          showClose: true,
          message: "请填写密码",
          type: "warning"
        });

        return;
      }
      if (regex.isEmpty(this.surepassword)) {
        this.$message({
          showClose: true,
          message: "请填写确认密码",
          type: "warning"
        });

        return;
      }
      if (this.password == this.surepassword) {
        this.submitNewPassword();
      } else {
        this.$message({
          showClose: true,
          message: "两次填写的密码不一致",
          type: "warning"
        });
      }
    },
    submitNewPassword: function() {
      var params = {
        old_password: this.old_password,
        password: this.password
      };
      this.$client
        .updatePersonalData(params)
        .then(res => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: this.isShowOldPwd ? "修改成功" : "设置成功",
              type: "success"
            });
            this.isShowChangepasswordPop = false;
            this.$emit("updata-bind-success");
            this.resetFrom();
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
    },
    resetFrom: function() {
      this.old_password = "";
      this.password = "";
      this.surepassword = "";
    }
  }
};
</script>
<style lang="less" scoped>
.change-passwo-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  .change-passwo-total {
    position: absolute;
    width: 553px;
    height: 528px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    .change-passwo-all {
      width: 489px;
      height: 488px;
      align-items: flex-end;
      & > em {
        width: 22px;
        height: 22px;
        background: url("../../../assets/login/close_arrow_icon.png") no-repeat
          center center;
        background-size: 22px 22px;
        cursor: pointer;
      }
      & > dl {
        width: 513px;
        margin-top: 8px;
        .change-passwo-title {
          width: 100%;
          & > h3 {
            width: 100%;
            text-align: center;
            height: 21px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(48, 41, 41, 1);
            line-height: 21px;
          }
        }
        .change-passwo-input {
          width: 100%;
          margin-top: 40px;
          & > h3 {
            width: 393px;
            margin-bottom: 20px;
            & > strong {
              height: 21px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(48, 41, 41, 1);
              line-height: 21px;
              margin-bottom: 6px;
            }
            & > span {
              width: 363px;
              height: 52px;
              border: 1px solid rgba(221, 221, 221, 1);
              padding: 0px 15px;
              justify-content: space-between;
              align-items: center;
              flex-shrink: 1;
              & > input {
                display: block;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                flex-grow: 1;
              }
            }
          }
        }
        .change-passwo-next-botton {
          margin-top: 20px;
          width: 100%;
          & > span {
            width: 393px;
            height: 52px;
            background: rgba(48, 41, 41, 1);
            text-align: center;
            line-height: 52px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pop/my/change_password_cpn.vue